import { SvgIcon, SvgIconProps } from '@mui/material';
import { FC } from 'react';

interface ViolationIconProps extends SvgIconProps {
  fillColor?: string; 
}

export const ViolationIcon: FC<ViolationIconProps> = ({ fillColor = '#00598E', ...props }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M12.417 1.66663H7.58366C7.017 1.66663 6.21699 1.99996 5.81699 2.39996L2.40033 5.81664C2.00033 6.21664 1.66699 7.01663 1.66699 7.5833V12.4166C1.66699 12.9833 2.00033 13.7833 2.40033 14.1833L5.81699 17.6C6.21699 18 7.017 18.3333 7.58366 18.3333H12.417C12.9837 18.3333 13.7837 18 14.1837 17.6L17.6003 14.1833C18.0003 13.7833 18.3337 12.9833 18.3337 12.4166V7.5833C18.3337 7.01663 18.0003 6.21664 17.6003 5.81664L14.1837 2.39996C13.7837 1.99996 12.9837 1.66663 12.417 1.66663Z"
        stroke={fillColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M7.08301 12.9167L12.9163 7.08337"
        stroke={fillColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12.9163 12.9167L7.08301 7.08337"
        stroke={fillColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};
